/* eslint-disable @typescript-eslint/member-ordering */

import global from '@applications/global';

export default class Route {
    public static get Billing(): string {
        return '/billing';
    }

    public static get BillingAccounts(): string {
        return 'accounts';
    }

    public static get SummaryRoute(): string {
        return `summary/*`
    }

    public static get Home(): string {
        return `home`
    }

    public static get InvoiceSummaryRoute(): string {
        return `summary/invoices`
    }
    public static get EnquirySummaryRoute(): string {
        return `summary/enquiry`
    }

    public static get InvoiceSummaryOlderRoute(): string {
        return `summaryold/invoices`
    }
    public static SelectedSummaryRoute(billingAccount: string): string {
        return `summary?billingAccount=${billingAccount}`
    }
    public static SelectedEnquiryRoute(billingAccount: string): string {
        return `summary/enquiry?billingAccount=${billingAccount}`
    }
    public static SelectedEnquiryRouteWithCidn(billingAccount: string, cidn?: string): string {
        return `summary/enquiry?billingAccount=${billingAccount}&cidn=${cidn}`
    }
    public static SelectedInvoiceSummary(billingAccount: string): string {
        return `summary/invoices?billingAccount=${billingAccount}`
    }


    public static SelectedPaymentSummary(billingAccount: string): string {
        return `summary/payments?billingAccount=${billingAccount}`
    }

    public static SelectedInvoiceSummaryWithCidn(billingAccount: string, cidn?: string): string {
        return `summary/invoices?billingAccount=${billingAccount}&cidn=${cidn}`
    }

    public static SelectedPaymentSummaryWithCidn(billingAccount: string, cidn?: string): string {
        return `summary/payments?billingAccount=${billingAccount}&cidn=${cidn}`
    }

    public static SelectedCredit(billingAccount: string): string {
        return `summary/credits?billingAccount=${billingAccount}`
    }

    public static SelectedCreditWithCidn(billingAccount: string, cidn?: string): string {
        return `summary/credits?billingAccount=${billingAccount}&cidn=${cidn}`
    }

    public static get PaymentsSummaryRoute(): string {
        return `summary/payments`
    }

    public static get CreditsRoute(): string {
        return `summary/credits`
    }

    public static SelectedBillingAccounts(billingAccount: string): string {
        return `accounts?billingAccount=${billingAccount}`;
    }

    public static BillingDashboardWithAccount(billingAccount: string): string {
        return `/app/billing?billingAccount=${billingAccount}`;
    }

    public static get InvoiceDetailsRoute(): string {
        return 'accounts/details';
    }
    public static get InvoiceDetailsRouteLegacy(): string {
        return 'accounts/details/legacy';
    }
    public static get PaymentDetailsRoute(): string {
        return 'payments/details'
    }
    public static get AdjustmentDetailsRoute(): string {
        return 'adjustments/details'
    }

    public static ViewOlderInvoices(accountId: string): string {
        return `summaryold/invoices?billingAccount=${accountId}`
    }

    public static get PaymentOption(): string {
        return `payment/paymentoption`;
    }

    public static get InvoiceSummaryDetailsRoute(): string {
        return `summary/invoiceDetails/:invoiceNumber`
    }

    public static get PaymentMethods(): string {
        return `payment/paymentmethods`;
    }

    public static get PayByCreditCard(): string {
        return `payby/creditcard`;
    }

    public static get PayByCreditCardSuccess(): string {
        return `paybycreditcard/success`;
    }
    public static get SetupDirectDebit(): string {
        return `payment/setupdirectdebit`;
    }

    public static get UpdateDirectDebit(): string {
        return `payment/updatedirectdebit`;
    }

    public static SelectedPaymentOption(billingAccount: string): string {
        return `payment/paymentoption?billingAccount=${billingAccount}`
    }

    public static SelectedPaymentMethods(billingAccount: string): string {
        return `payment/paymentmethods?billingAccount=${billingAccount}`
    }

    public static ViewPaymentDetails(accountId: string, transactionId: number): string {
        return `payments/details?transactionId=${transactionId}&accountId=${accountId}`
    }
    public static ViewInvoiceDetails(accountId: string, invoiceNumber: string, cidn?: string, newEnqHash?: string): string {
        const hashInUrl = newEnqHash ? newEnqHash : '';
        return cidn ? `accounts/details?invoiceNumber=${invoiceNumber}&accountId=${accountId}&cidn=${cidn}` +
            hashInUrl : `accounts/details?invoiceNumber=${invoiceNumber}&accountId=${accountId}` + hashInUrl;
    }
    public static ViewInvoiceDetailsLegacy(accountId: string, billDate?: string): string {
        return `accounts/details/legacy?accountId=${accountId}&billDate=${billDate}`;
    }
    public static ViewEnquiryDetails(accountId: string, ticketNumber: string, cidn?: string): string {
        const enqUrl = accountId ?
            `enquiry/details?caseNumber=${ticketNumber}&accountId=${accountId}`
            :
            `enquiry/details?caseNumber=${ticketNumber}&cidn=${cidn}`
            ;
        return enqUrl;
    }
    public static ViewAdjustmentDetails(accountId: string, adjustmentId: number | string): string {
        return `adjustments/details?adjustmentId=${adjustmentId}&accountId=${accountId}`
    }

    public static get RepaymentDetailsRoute(): string {
        return `repayment/:chargeId/:statementNumber`;
    }
    public static ViewRepaymentDetails(chargeId: number, accountId: string, invoiceNumber: string,
        statementNumber: string): string {
        return `repayment/${chargeId}/${statementNumber}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }

    public static get RepaymentDetailsRouteNew(): string {
        return `repayment/:chargeId/`;
    }
    public static ViewNewRepaymentDetails(chargeId: number, accountId: string, invoiceNumber: string): string {
        return `repayment/${chargeId}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }

    public static get FeaturePackDetailsRoute(): string {
        return `featurePack/:chargeId/:statementNumber`;
    }
    public static ViewFeaturePackDetails(chargeId: number, accountId: string, invoiceNumber: string,
        statementNumber: string): string {
        return `featurePack/${chargeId}/${statementNumber}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }

    public static get FeaturePackDetailsRouteNew(): string {
        return `featurePack/:chargeId`;
    }
    public static ViewNewFeaturePackDetails(chargeId: number, accountId: string, invoiceNumber: string): string {
        return `featurePack/${chargeId}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }

    public static get RecurringChargeDetailsNewRoute(): string {
        return `recurring/:chargeId/`;
    }
    public static ViewNewRecurringChargesDetails(chargeId: number, accountId: string, invoiceNumber: string): string {
        return `recurring/${chargeId}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }

    public static get RecurringChargeDetailsRoute(): string {
        return `recurring/:chargeId/:statementNumber`;
    }
    public static ViewRecurringChargesDetails(chargeId: number, accountId: string, invoiceNumber: string,
        statementNumber: string): string {
        return `recurring/${chargeId}/${statementNumber}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }

    public static get OrderDetailsRoute(): string {
        return `order/:chargeId/:statementNumber`;
    }
    public static ViewOrderDetails(chargeId: number, accountId: string, invoiceNumber: string,
        statementNumber: string): string {
        return `order/${chargeId}/${statementNumber}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }

    public static get OrderDetailsRouteNew(): string {
        return `order/:chargeId/`;
    }
    public static ViewNewOrderDetails(chargeId: number, accountId: string, invoiceNumber: string): string {
        return `order/${chargeId}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }
    public static get RefundAdjustmentDetailRoute(): string {
        return `adjustmentsDetails/:index`;
    }
    public static ViewRefundAdjustmentDetail(index: number, accountId: string, invoiceNumber: string): string {
        return `adjustmentsDetails/${index}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }
    public static get GetUsageDetailsRoute(): string {
        return `accounts/usageDetails`;
    }

    public static UsageDetailsRoute(accountId: string, invoiceNumber: string): string {
        return `accounts/usageDetails?invoiceNumber=${invoiceNumber}&accountId=${accountId}`;
    }

    public static get NewEnquiryRoute(): string {
        return `accounts/newEnquiry`;
    }
    public static NewEnquiryFormRoute(accountId: string, invoiceNumber: string): string {
        return `accounts/newEnquiry?invoiceNumber=${invoiceNumber}&accountId=${accountId}`;
    }
    public static get enquiryDetail(): string {
        return `accounts/enquiryDetail`;
    }

    public static get enquiryList(): string {
        return `accounts/enquiryList`;
    }
    public static EnquirySubmitRoute(accountId: string, invoiceNumber: string, caseId?: string): string {
        return `accounts/enquirySubmitted/${caseId}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`;
    }
    public static get EnquirySubmittedRoute(): string {
        return `accounts/enquirySubmitted/:caseId`;
    }

    public static get DiscountDetailsRoute(): string {
        return `discount/:chargeId/:statementNumber`;
    }

    public static ViewDiscountDetails(chargeId: number, accountId: string, invoiceNumber: string,
        statementNumber: string): string {
        return `discount/${chargeId}/${statementNumber}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }

    public static get DiscountDetailsRouteNew(): string {
        return `discount/:chargeId`;
    }
    public static ViewNewDiscountDetails(chargeId: number, accountId: string, invoiceNumber: string): string {
        return `discount/${chargeId}?invoiceNumber=${invoiceNumber}&accountId=${accountId}`
    }

    public static get GetEnquiryDetailsRoute(): string {
        return `enquiry/details`;
    }

    public static get GetDirectDebitServiceAgreementRoute(): string {
        return `agreement/direct-debit-service-agreement`;
    }

    public static get SavedPaymentMethods(): string {
        return `paymentOption/savedPaymentMethods`;
    }

    public static get AddNewPaymentMethods(): string {
        return `paymentOption/addNewpaymentMethod`;
    }

    public static get AddPaymentMethodSuccess(): string {
        return `paymentOption/addNewpaymentMethodSuccess`;
    }

    public static get UnsuccessfulCancelRoute(): string {
        return `paymentOption/failure`;
    }
    public static get directDebitSuccess(): string {
        return `paymentmethods/directDebitSuccess`;
    }
    public static get directDebitError(): string {
        return `paymentmethods/directDebitError`;
    }
    public static get IntBillingLandingRoute(): string {
        return `landing-page`;
    }

    public static submitEnquiryFormBillingInt(billingAccountId: string,
        defaultCidn: string, selectedCidn: string, billingType: string = '',
        refNumber: string = ''): string {
        const billingEnquiryNewFormInt = global.applications.Billing.billingEnquiryNewFormInt || false;
        const formPath = (billingEnquiryNewFormInt) ? 'new-enquiry-form' : 'new-enquiry';
        return billingType && refNumber ? (
            `/app/customer-support/${formPath}?category=Billing` +
            `&billingAccountId=${billingAccountId}&selectedCidn` +
            `=${selectedCidn}&defaultCidn=${defaultCidn}&billingType=${billingType}&refNumber=${refNumber}`
        ) : (
            `/app/customer-support/${formPath}?category=Billing` +
            `&billingAccountId=${billingAccountId}&selectedCidn` +
            `=${selectedCidn}&defaultCidn=${defaultCidn}`
        );
    }
    public static get detailedEnquiryForm(): string {
        return `/app/customer-support/detailed-enquiry-form`;
    }
    public static get newEnquiry(): string {
        return '/app/customer-support/new-enquiry?category=Billing';
    }
    public static get GetTAnalystError(): string {
        return `auth/error`;
    }
    public static get CallingLineIdentifier(): string {
        return 'summary/voice-services/usage-reports/cli'
    }
    public static getInvoiceSummaryDetailsRoute(billingAccount: string, invoiceNumber: string, cidn: string): string {
        return `summary/invoiceDetails/${invoiceNumber}?billingAccount=${billingAccount}&cidn=${cidn}`
    }
}
